import { Component, OnInit } from '@angular/core';
import { BaseCtl } from '../common/base.component';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { EventService } from '../common/service/event.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent extends BaseCtl  {

 
  public userContext = {name : localStorage.getItem('name')};
  //Change menu event
  private changeMenu: Subscription;
  

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute, public eService: EventService) {
    super(locator.endpoints.AUTH, locator, route);
  }

  ngOnInit() {
    let _self = this;

    this.changeMenu = this.eService.changeMenu.subscribe(
      text => {
        _self.userContext = _self.locator.userContext;
      }
    );
    console.log("userContext",this.userContext);
  }

  /**
   * Check if user is logged in 
   */
  isLogin() {
    let check = localStorage.getItem('loginId');
    if (check != "null" && check != null) {
      return true;
    } else {
      return false;
  }


  
  }

  

  isNcs() {
    let check = localStorage.getItem('orgId');
    if ((check == "22" && check != null) || (check == "74" && check != null)) {
      return true;
    } else {
      return false;
  }


  
  }




}
